import React, { useMemo } from "react";
import Breadcrumbs from "../../../components/BreadCrumbs";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import messages from "../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../utils/RoutesPaths";
import { eventStatuses } from "../../../utils/Constants";
import {
  COMPANY_EVENT_DRAFT_TAB,
  COMPANY_EVENT_PENDING_TAB,
} from "../../../utils/companyPortal/eventListTabs";
import { appendActiveUrlTabBreadcrumb } from "../../../utils/Helpers";
import CompanyPortalEventsList from "../../../components/CompanyPortal/EventsList";

import "./Events.scss";

const COMPANY_EVENT_LIST_TABS = [
  eventStatuses.ongoing,
  eventStatuses.upcoming,
  eventStatuses.past,
  COMPANY_EVENT_DRAFT_TAB,
  COMPANY_EVENT_PENDING_TAB,
  eventStatuses.cancelled,
];

const Events = () => {
  const location = useLocation();
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const eventTabs = events.listEvents.eventTabs;

  const listTabLabels = useMemo(
    () => ({
      [eventStatuses.ongoing]: eventTabs.ongoing,
      [eventStatuses.upcoming]: eventTabs.upcoming,
      [eventStatuses.past]: eventTabs.previous,
      [COMPANY_EVENT_DRAFT_TAB]: eventTabs.draft,
      [COMPANY_EVENT_PENDING_TAB]: eventTabs.pending,
      [eventStatuses.cancelled]: eventTabs.cancelled,
    }),
    [eventTabs],
  );

  const activeStatus = useMemo(() => {
    const tab = new URLSearchParams(location.search).get("tab");
    return tab && COMPANY_EVENT_LIST_TABS.includes(tab)
      ? tab
      : eventStatuses.ongoing;
  }, [location.search]);

  const breadcrumbList = useMemo(
    () =>
      appendActiveUrlTabBreadcrumb({
        breadcrumbs: [
          {
            path: "",
            label: events.listEvents.listEventsBreadcrumb,
          },
        ],
        activeTab: activeStatus,
        defaultTab: eventStatuses.ongoing,
        tabLabelsByValue: listTabLabels,
        viewPathname: ROUTE_PATHS.companyEvents,
        search: location.search,
      }),
    [
      activeStatus,
      events.listEvents.listEventsBreadcrumb,
      listTabLabels,
      location.search,
    ],
  );

  return (
    <div className="events-list-container">
      <div className="page-title-margin">
        <Breadcrumbs
          list={breadcrumbList}
          BreadCrumbHasBackIcon={false}
        />
      </div>
      <div className="events-list-container__body">
        <CompanyPortalEventsList />
      </div>
    </div>
  );
};

export default Events;
